import { Divider } from '@mui/material';
import { Restricted } from '@procureai/permissions-ui';
import { NavDrawerProps } from '@procureai/ui-mui';
import { Trans } from 'react-i18next';

import { AstroSmartLinkDomain } from '@/generated/gql/graphql';
import { NavId, FeatureFlag } from '~/common/types';
import { NavDrawerSimple } from '~/components/NavDrawerSimple/NavDrawerSimple';
import { SmartLinksEditDialog } from '~/components/SmartLinksEditDialog/SmartLinksEditDialog';
import { SmartLinksNavList } from '~/components/SmartLinksNavList/SmartLinksNavList';

export const InternalToolsDrawer = (props: NavDrawerProps) => {
  return (
    <NavDrawerSimple navId={NavId.internalTools} {...props}>
      <Restricted needs={{ feature: FeatureFlag.SMART_LINKS }}>
        <SmartLinksNavList domain={AstroSmartLinkDomain.TOOLS_1} label={<Trans i18nKey="Nav.internalToolsLinks1" />}>
          <SmartLinksEditDialog
            domain={AstroSmartLinkDomain.TOOLS_1}
            label="internalToolsLinksManage"
            dialogTitle="internalToolsLinks1"
          />
        </SmartLinksNavList>

        <Divider />

        <SmartLinksNavList domain={AstroSmartLinkDomain.TOOLS_2} label={<Trans i18nKey="Nav.internalToolsLinks2" />}>
          <SmartLinksEditDialog
            domain={AstroSmartLinkDomain.TOOLS_2}
            label="internalToolsLinksManage"
            dialogTitle="internalToolsLinks2"
          />
        </SmartLinksNavList>

        <Divider />

        <SmartLinksNavList domain={AstroSmartLinkDomain.TOOLS_3} label={<Trans i18nKey="Nav.internalToolsLinks3" />}>
          <SmartLinksEditDialog
            domain={AstroSmartLinkDomain.TOOLS_3}
            label="internalToolsLinksManage"
            dialogTitle="internalToolsLinks3"
          />
        </SmartLinksNavList>
      </Restricted>
    </NavDrawerSimple>
  );
};
